import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

const SetupButton = styled(Button)(({ theme }) => ({
  color: theme.palette.color1,
  backgroundColor: theme.palette.color2,
  borderRadius: "18px",
  minWidth: "40vw",
  fontSize: 30,
}));

const DropDownButton = styled(Button)(({ theme }) => ({
  color: theme.palette.color2,
  backgroundColor: "transparent",
  border: `none`,
  borderBottom: `1px solid `,
  width: "150px",
  fontSize: 18,
  justifyContent: "space-between",
  paddingLeft: "16px",
  paddingRight: "16px",
  textTransform: "none",
  backdropFilter: "blur(20px) invert(5%)",
  webkitBackdropFilter: "blur(10px) invert(5%)"
}));

const DropDownMenu = styled(Menu)(({ theme }) => ({
  "& .MuiPaper-root": {
    width: "150px",
    borderRadius: "12px",
    color: theme.palette.color2,
    backgroundColor: "transparent",
    backdropFilter: "blur(20px) invert(5%)",
    webkitBackdropFilter: "blur(10px) invert(5%)"
  },
}));

const DropDownMenuItem = styled(MenuItem)(({ theme }) => ({
  fontSize: 18,
  paddingTop: 10,
  paddingBottom: 10,
}));

const ProfileButton = styled(Button)(({ theme }) => ({
  color: theme.palette.color1,
  backgroundColor: theme.palette.color2,
  borderRadius: "4px",
  minWidth: "40vw",
  fontSize: 30,
  fontWeight: "bold",
}));

export {
  SetupButton,
  DropDownButton,
  DropDownMenu,
  DropDownMenuItem,
  ProfileButton,
};
